import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaCalendarAlt, FaEnvelope, FaTimes } from 'react-icons/fa'; // Importing icons

const Float = () => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div
            className={`fixed bottom-4 right-4 z-50 ${
                isExpanded ? 'w-64 h-auto p-4' : 'w-12 h-12'
            } bg-white shadow-lg transition-all duration-300 flex ${
                isExpanded ? 'flex-col gap-4 rounded-lg' : 'justify-center items-center rounded-full'
            }`}
        >
            {!isExpanded ? (
                <button
                    className="w-full h-full flex justify-center items-center bg-accent text-primary rounded-full"
                    aria-label="Expand Assistance Options"
                    onClick={toggleExpand}
                >
                    <FaEnvelope size={20} /> {/* Contact Us Icon */}
                </button>
            ) : (
                <>
                    {/* Close Button */}
                    <button
                        className="absolute top-2 right-2 bg-primary text-white rounded-full p-1 hover:bg-primary-dark transition"
                        aria-label="Close Assistance Options"
                        onClick={toggleExpand}
                    >
                        <FaTimes size={16} /> {/* Close Icon */}
                    </button>

                    {/* Textual Content */}
                    <div className="text-center">
                        <p className="text-primary font-nunito-sans text-sm md:text-base font-semibold">
                            Need Assistance?
                        </p>
                        <p className="text-primary font-nunito-sans text-xs md:text-sm">
                            Book an appointment, call us, or email us for quick support!
                        </p>
                    </div>
                    {/* Book an Appointment Button */}
                    <div className="px-4 md:px-8 flex justify-center items-center gap-2.5">
                        <Link
                            to="https://calendar.app.google/p4WcBypUePQVXCHh9"
                            className="px-6 py-2 border border-primary text-primary rounded-md font-nunito-sans text-sm md:text-base hover:bg-primary hover:text-accent transition shadow-lg flex items-center gap-2"
                        >
                            <FaCalendarAlt size={16} /> {/* Calendar Icon */}
                            Appointment
                        </Link>
                    </div>
                    {/* Call Now Button */}
                    <div className="px-4 md:px-8 flex justify-center items-center gap-2.5">
                        <a
                            href="tel:+12013332931"
                            className="px-6 py-2 border border-primary text-primary rounded-md font-nunito-sans text-sm md:text-base hover:bg-primary hover:text-accent transition shadow-lg flex items-center gap-2"
                        >
                            <FaPhoneAlt size={16} /> {/* Phone Icon */}
                            Call Now
                        </a>
                    </div>
                    {/* Email Us Button */}
                    <div className="px-4 md:px-8 flex justify-center items-center gap-2.5">
                        <a
                            href="mailto:sales@thelumiglass.com"
                            className="px-6 py-2 border border-primary text-primary rounded-md font-nunito-sans text-sm md:text-base hover:bg-primary hover:text-accent transition shadow-lg flex items-center gap-2"
                        >
                            <FaEnvelope size={16} /> {/* Email Icon */}
                            Email Us
                        </a>
                    </div>
                </>
            )}
        </div>
    );
};

export default Float;